/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type RetrieveApiV2LedgersLedgerCanisterIdGetRequest = {
  ledgerCanisterId: string;
};

/** @internal */
export const RetrieveApiV2LedgersLedgerCanisterIdGetRequest$inboundSchema:
  z.ZodType<
    RetrieveApiV2LedgersLedgerCanisterIdGetRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    ledger_canister_id: z.string(),
  }).transform((v) => {
    return remap$(v, {
      "ledger_canister_id": "ledgerCanisterId",
    });
  });

/** @internal */
export type RetrieveApiV2LedgersLedgerCanisterIdGetRequest$Outbound = {
  ledger_canister_id: string;
};

/** @internal */
export const RetrieveApiV2LedgersLedgerCanisterIdGetRequest$outboundSchema:
  z.ZodType<
    RetrieveApiV2LedgersLedgerCanisterIdGetRequest$Outbound,
    z.ZodTypeDef,
    RetrieveApiV2LedgersLedgerCanisterIdGetRequest
  > = z.object({
    ledgerCanisterId: z.string(),
  }).transform((v) => {
    return remap$(v, {
      ledgerCanisterId: "ledger_canister_id",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace RetrieveApiV2LedgersLedgerCanisterIdGetRequest$ {
  /** @deprecated use `RetrieveApiV2LedgersLedgerCanisterIdGetRequest$inboundSchema` instead. */
  export const inboundSchema =
    RetrieveApiV2LedgersLedgerCanisterIdGetRequest$inboundSchema;
  /** @deprecated use `RetrieveApiV2LedgersLedgerCanisterIdGetRequest$outboundSchema` instead. */
  export const outboundSchema =
    RetrieveApiV2LedgersLedgerCanisterIdGetRequest$outboundSchema;
  /** @deprecated use `RetrieveApiV2LedgersLedgerCanisterIdGetRequest$Outbound` instead. */
  export type Outbound =
    RetrieveApiV2LedgersLedgerCanisterIdGetRequest$Outbound;
}

export function retrieveApiV2LedgersLedgerCanisterIdGetRequestToJSON(
  retrieveApiV2LedgersLedgerCanisterIdGetRequest:
    RetrieveApiV2LedgersLedgerCanisterIdGetRequest,
): string {
  return JSON.stringify(
    RetrieveApiV2LedgersLedgerCanisterIdGetRequest$outboundSchema.parse(
      retrieveApiV2LedgersLedgerCanisterIdGetRequest,
    ),
  );
}

export function retrieveApiV2LedgersLedgerCanisterIdGetRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  RetrieveApiV2LedgersLedgerCanisterIdGetRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      RetrieveApiV2LedgersLedgerCanisterIdGetRequest$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'RetrieveApiV2LedgersLedgerCanisterIdGetRequest' from JSON`,
  );
}
